import { getEnvironmentVariablesValue } from "@utility/environmentVariables"

export const isDevelopmentEnvironment = process.env.NODE_ENV === "development"
export const isTestEnvironment = process.env.NODE_ENV === "test"
export const isProductionEnvironment = process.env.NODE_ENV === "production"

const computeCdnBaseUrl = () => {
    let cdnBaseUrlPath = getEnvironmentVariablesValue("CDN_BASE_URL") || "https://postgres.testlume.in/public/lumenore-ui"
    if (isProductionEnvironment) {
        cdnBaseUrlPath = getEnvironmentVariablesValue("CDN_BASE_URL") || `public${getEnvironmentVariablesValue("MICROFRONTEND_PROJECT_PATH") || '/lumenore-ui'}`
    }
    else {
        /* do nothing */
    }
    return cdnBaseUrlPath
}

const computeBaseUrl = () => {
    if (isProductionEnvironment) {
        return getEnvironmentVariablesValue("API_BASE_URL") || "/api"
    }
    else {
        return getEnvironmentVariablesValue("API_BASE_URL") || "https://rsh.lumenore.com/api"
    }
}

export const cdnBaseUrl = computeCdnBaseUrl();
export default computeBaseUrl();

